import Vue from "vue";
import Vuex from "vuex";
import createVuexAlong from "vuex-along";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 用户身份信息
    role: "unLogin", // 默认为unLogin
    afField: "", // 默认无牛场
    region: "", // 默认无地区
    fieldId: "", // 牧场id
    token: "", // JWT token

    // 导航栏信息
    title: [],
    showLoading: false,
    notificationQueue: [],

    // 检索数据的条件
    date_range: [], // 时间范围
    selected_devs: "", // 选中的设备
    selected_algoName: undefined, // 选中的数据包算法
    is_insert_empty: false, // 是否插空
    refresh: 0, // 是否刷新页面
    select_bags: undefined, // 是否补包
  },
  getters: {},
  mutations: {
    pushTitle(state, newTitle) {
      state.title.push(newTitle);
    },
    popTitle(state) {
      state.title.pop();
    },
    changeTitle(state, newTitle) {
      state.title = [newTitle];
    },
    reverseLoading(state) {
      state.showLoading = !state.showLoading;
    },
    addNotification(state, notification) {
      state.notificationQueue.push(notification);
    },
    popNotification(state) {
      state.notificationQueue.shift();
    },
    setDateRange(state, date_range) {
      state.date_range = date_range;
    },
    setSelectBags(state, select_bags) {
      state.select_bags = select_bags;
    },
    setSelectedDevs(state, selected_devs) {
      state.selected_devs = selected_devs;
    },
    setSelectedAlgoName(state, selected_algoName) {
      state.selected_algoName = selected_algoName;
    },
    toggleInsertEmpty(state) {
      state.is_insert_empty = !state.is_insert_empty;
    },
    refreshData(state) {
      state.refresh++;
    },
    updateUserInfo(state, newUserInfo) {
      state.role = newUserInfo.role;
      state.afField = newUserInfo.afField;
      state.region = newUserInfo.region;
      state.fieldId = newUserInfo.fieldId;
      state.token = newUserInfo.token;
    },
    clearAuth(state) {
      state.role = "unLogin";
      state.afField = "";
      state.region = "";
      state.fieldId = "";
      state.token = "";
    },
  },
  actions: {
    pushTitle({ commit }, newTitle) {
      commit("pushTitle", newTitle);
    },
    popTitle({ state, commit }, times) {
      if (state.title.length <= 1) return null;
      let pop = state.title[state.title.length - times];
      while (times-- && pop !== null) {
        commit("popTitle");
      }
    },
    changeTitle({ commit }, newTitle) {
      commit("changeTitle", newTitle);
    },
    reverseLoading({ commit }) {
      commit("reverseLoading");
    },
    addNotification({ commit }, notification) {
      const routePath =
        notification.routePath ||
        window.location.hash.replace(/^#/, "") ||
        window.location.pathname;
      commit("addNotification", { ...notification, routePath });
    },
    getNotification({ state, commit }) {
      let notification = state.notificationQueue[0];
      commit("popNotification");
      return notification;
    },
    setDateRange({ commit }, date_range) {
      commit("setDateRange", date_range);
    },
    setSelectBags({ commit }, select_bags) {
      commit("setSelectBags", select_bags);
    },
    setSelectedDevs({ commit }, selected_devs) {
      commit("setSelectedDevs", selected_devs);
    },
    setSelectedAlgoName({ commit }, selected_algoName) {
      commit("setSelectedAlgoName", selected_algoName);
    },
    toggleInsertEmpty({ commit }) {
      commit("toggleInsertEmpty");
    },
    refreshData({ commit }) {
      commit("refreshData");
    },
    updateUserInfo({ commit }, newUserInfo) {
      commit("updateUserInfo", newUserInfo);
    },
    clearAuth({ commit }) {
      commit("clearAuth");
    },
  },
  modules: {},
  plugins: [
    createVuexAlong({
      name: "comm-frontend-auth",
      local: {
        list: ["role", "token", "afField", "region", "fieldId"],
        isFilter: true,
      },
    }),
  ],
});
